import script from "./BaseTableLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTableLoader.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTableLoader.vue?vue&type=style&index=0&id=09c93677&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09c93677"]])

export default __exports__